import { render } from "./LocationCard.vue?vue&type=template&id=a7b54ec0"
import script from "./LocationCard.vue?vue&type=script&lang=js"
export * from "./LocationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__